import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/policies`;

export const policyService = {
  async listPolicies(filters = {}) {
    const params = new URLSearchParams();
    if (filters.regulatory_framework) params.append('regulatory_framework', filters.regulatory_framework);
    if (filters.status) params.append('status', filters.status);
    const query = params.toString();
    const response = await axios.get(`${API_BASE}${query ? `?${query}` : ''}`);
    return response.data;
  },

  async getPolicy(policyId) {
    const response = await axios.get(`${API_BASE}/${policyId}`);
    return response.data;
  },

  async createPolicy(data) {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  async updatePolicy(policyId, data) {
    const response = await axios.put(`${API_BASE}/${policyId}`, data);
    return response.data;
  },

  async activatePolicy(policyId) {
    const response = await axios.post(`${API_BASE}/${policyId}/activate`);
    return response.data;
  },

  async retirePolicy(policyId) {
    const response = await axios.post(`${API_BASE}/${policyId}/retire`);
    return response.data;
  },

  async evaluateEntity(entityType, entityData, regulatoryFramework, policyEngine) {
    const response = await axios.post(`${API_BASE}/evaluate`, {
      entity_type: entityType,
      entity_data: entityData,
      regulatory_framework: regulatoryFramework,
      policy_engine: policyEngine,
    });
    return response.data;
  },

  async evaluateWithOPA(entityType, entityData, regulatoryFramework, context) {
    const response = await axios.post(`${API_BASE}/evaluate/opa`, {
      entity_type: entityType,
      entity_data: entityData,
      regulatory_framework: regulatoryFramework,
      context: context || {},
    });
    return response.data;
  },

  async checkOPAHealth() {
    const response = await axios.get(`${API_BASE}/opa/health`);
    return response.data;
  },
};

export default policyService;
